import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTrash } from "../../utilities/fontawesomeIcons";
import { useAppContext } from "../../AppProvider";
import { Button } from "../../Models/Button";

const ButtonDelete: React.FC<Button> = ({
  children,
  className = "",
  onClick,
  disabled = false,
  loading = false,
  icon = true,
}) => {
  const { dictionary } = useAppContext();

  return (
    <button
      className={`button-1 button-1-danger ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <FontAwesomeIcon icon={faSpinner} spin />
      ) : (
        <>
          {icon && <FontAwesomeIcon icon={faTrash} />}
          {children || dictionary.actions.delete}
        </>
      )}
    </button>
  );
};

export default ButtonDelete;
